// Helpers to build responsive image URLs that hit the backend image transform
// endpoint /api/files/<path>?w=<width>&fmt=<webp|jpeg|png>

const API = process.env.REACT_APP_BACKEND_URL;

/** Build a single transformed URL */
export const fileUrl = (path, { w, fmt } = {}) => {
  if (!path) return '';
  const encodedPath = path.split('/').map(encodeURIComponent).join('/');
  const base = `${API}/api/files/${encodedPath}`;
  const qs = [];
  if (w) qs.push(`w=${w}`);
  if (fmt) qs.push(`fmt=${fmt}`);
  return qs.length ? `${base}?${qs.join('&')}` : base;
};

/** WebP srcset string at standard widths */
export const webpSrcSet = (path, widths = [256, 512, 1024]) =>
  widths.map((w) => `${fileUrl(path, { w, fmt: 'webp' })} ${w}w`).join(', ');

/** JPEG fallback srcset at the same widths */
export const jpegSrcSet = (path, widths = [256, 512, 1024]) =>
  widths.map((w) => `${fileUrl(path, { w, fmt: 'jpeg' })} ${w}w`).join(', ');
